import { render, staticRenderFns } from "./ContentRenderer.vue?vue&type=template&id=fa79e748&scoped=true"
import script from "./ContentRenderer.vue?vue&type=script&lang=js"
export * from "./ContentRenderer.vue?vue&type=script&lang=js"
import style0 from "./ContentRenderer.vue?vue&type=style&index=0&id=fa79e748&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa79e748",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa79e748')) {
      api.createRecord('fa79e748', component.options)
    } else {
      api.reload('fa79e748', component.options)
    }
    module.hot.accept("./ContentRenderer.vue?vue&type=template&id=fa79e748&scoped=true", function () {
      api.rerender('fa79e748', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ContentRenderer.vue"
export default component.exports